import React, { useRef, useEffect } from 'react';

const TYPE_CONFIG = {
  specialist: {
    className: 'doctor-schedule-mgmt__badge--specialist',
    tooltipLabel: 'Specialist Clinic',
  },
  executive: {
    className: 'doctor-schedule-mgmt__badge--executive',
    tooltipLabel: 'Executive Clinic',
  },
  teleconsultation: {
    className: 'doctor-schedule-mgmt__badge--teleconsultation',
    tooltipLabel: 'Teleconsultation',
  },
  emergency: {
    className: 'doctor-schedule-mgmt__badge--emergency',
    tooltipLabel: 'Emergency',
  },
};

function SourceIndicator({ source }) {
  if (source === 'afya') {
    return (
      <span className="doctor-schedule-mgmt__badge-source doctor-schedule-mgmt__badge-source--afya">
        <span className="doctor-schedule-mgmt__badge-source-dot" />
        Afya
      </span>
    );
  }
  return (
    <span className="doctor-schedule-mgmt__badge-source doctor-schedule-mgmt__badge-source--internal">
      Internal
    </span>
  );
}

function ScheduleBadge({ fromTime, toTime, type, label, source, size = 'normal', scheduleLabels = {} }) {
  const ref = useRef(null);
  const config = TYPE_CONFIG[type] || TYPE_CONFIG.specialist;
  const tooltipLabel = scheduleLabels[type] || config.tooltipLabel;
  const sourceText = source === 'afya' ? 'Afya' : 'Internal';
  const tooltipText = `${tooltipLabel} \u2022 ${fromTime} - ${toTime} \u2022 ${sourceText}`;

  useEffect(() => {
    const el = ref.current;
    if (el && window.$ && window.$.fn.tooltip) {
      $(el).tooltip({
        trigger: 'hover',
        container: 'body',
        template: '<div class="tooltip doctor-schedule-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
      });
    }
    return () => {
      if (el && window.$ && window.$.fn.tooltip) {
        $(el).tooltip('dispose');
      }
    };
  }, [tooltipText]);

  if (size === 'mini') {
    return (
      <span
        ref={ref}
        className={`doctor-schedule-mgmt__badge doctor-schedule-mgmt__badge--mini ${config.className}`}
        data-toggle="tooltip"
        data-placement="top"
        title={tooltipText}
      >
        {fromTime}
      </span>
    );
  }

  return (
    <div
      ref={ref}
      className={`doctor-schedule-mgmt__badge ${config.className}`}
      data-toggle="tooltip"
      data-placement="top"
      title={tooltipText}
    >
      <div className="doctor-schedule-mgmt__badge-main">
        <span className="doctor-schedule-mgmt__badge-time">
          {fromTime} - {toTime}
        </span>
        <SourceIndicator source={source} />
      </div>
      <span className="doctor-schedule-mgmt__badge-label">
        {label || type.toUpperCase()}
      </span>
    </div>
  );
}

export default ScheduleBadge;
